export default {

    name_ar:    'name AR',
    name_en:    'name EN',
    company_id: 'Company',
};
